// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/dist/cjs.js??ref--6-oneOf-4-1!../../postcss-loader/src/index.js??ref--6-oneOf-4-2!../../css-sprite-loader/index.js!../../svg-classic-sprite-loader/index.js??ref--6-oneOf-4-4!../index.js!../../postcss-loader/src/index.js??ref--6-oneOf-4-6!../../vue-cli-plugin-vusion/webpack/loaders/module-class-priority-loader/index.js!./fontface.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../vue-style-loader/lib/addStylesClient.js").default
var update = add("0a2c5853", content, true, {"sourceMap":false,"shadowMode":false});